import { RouteComponentProps, useParams } from 'react-router';

import { AppPage } from '../AppContent';
import Service from '../components/services/serviceContent/Service';
import { useServices } from '../hooks/ServiceHooks';
import { ServiceArray, WP_Service } from '../model/models';

interface ServicesPageProps extends RouteComponentProps {}

export interface ServicesProps {
  services: ServiceArray;
  slugs?: string[];
}
export interface ServiceProps {
  service: WP_Service;
}
export interface ServiceDisplayProps extends ServicesProps {
  slugs: string[];
}

export interface ServicesServiceProps extends ServiceProps, ServicesProps {}

const ServicesPages: React.FC<ServicesPageProps> = (props) => {
  const { services } = useServices();

  const { slug, slug1, slug2 }: any = useParams();

  const slugs: string[] = [slug, slug1, slug2].filter((s) => s);

  return (
    <AppPage>
      <div className="px-0 md:px-14">
        <Service services={services} slugs={slugs} />
      </div>
    </AppPage>
  );
};

export default ServicesPages;
